import React from 'react';
import Select from 'react-select';

const combobox = ({ id, col, attributes, value, label, datos, onChange }) => {

    const stilo = { display: !!attributes.hidden ? attributes.hidden : 'unset' };

    return (
        <div className={`col-sm-${col} col-md-${col}`} style={stilo}>
            <div className="form-group">
                <label htmlFor={id}>{label}</label>
                <Select
                    name={id}
                    id={id}
                    value={value}
                    onChange={onChange}
                    options={datos}
                    isDisabled={attributes.readOnly}
                    placeholder={label}
                >
                </Select>
            </div>
        </div>
    );
}

export default combobox;